<template>
  <v-tabs v-if="isAdmin" background-color="accent-4" class="elevation-2">
    <v-tab>Dashboarders</v-tab>
    <v-tab>Receipts</v-tab>
    <v-tab-item>
      <DashboarderStats />
    </v-tab-item>
    <v-tab-item>
      <ReceiptStats />
    </v-tab-item>
  </v-tabs>
  <div v-else>
    <DashboarderStats />
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import DashboarderStats from "./../components/Statistics/Dashboarders";
import ReceiptStats from "./../components/Statistics/Receipt";

export default {
  components: {
    DashboarderStats,
    ReceiptStats
  },
  computed: {
    ...mapGetters(["isAdmin"])
  }
};
</script>

<style>
</style>